export const parseKeyInitiativeFocusArea = (value: string | null | undefined): string[] => {
  if (typeof value !== 'string') return []

  return [
    ...new Set(
      value
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean)
    ),
  ]
}
